import { useEffect, useState } from 'react';
import { getApiToken } from '../../utilityFunctions/getApiToken';
import { getHeadersAuthorization } from '../../utilityFunctions/apiheadersauthorization';

const LandingDiscs = () => {
  const [discussions, setDiscussions] = useState([]);

  useEffect(() => {
    const fetchDiscussions = async () => {
      let token = await getApiToken();
      const url = process.env.REACT_APP_API_HOST + "discussions/getall";
      const response = await fetch(url, {
        method: 'POST',
        headers: getHeadersAuthorization(token)
      }).then(function(response) {
        return response;
      });

      const data = await response.json();
      const shuffled = data.items.sort(() => 0.5 - Math.random());
      const selected = shuffled.slice(0, 3);
      setDiscussions(selected);
    };

    fetchDiscussions();
  }, []);

  return (
    <div className="container my-4">
      <h2 className='landing-section-heading'>Discussioni recenti</h2>
      <div className="row">
        {discussions.map((disc, idx) => (
          <div key={idx} className="col-12 col-md-4 mb-3">
            <div className={`post-it-modern p-4 shadow-sm position-relative post-it-${idx}`}>
              <div className="emoji-pin">📌</div>
              <h5 className="mb-2 font-weight-bold">{disc.title}</h5>
              <p className="mb-0">{disc.description}</p>
              <div className="fold-corner"></div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default LandingDiscs;